import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

export interface AlgorithmVersion {
  version: string;
  lastUpdated: string;
}

@Injectable({
  providedIn: 'root'
})
export class AlgorithmVersionService {
  private apiUrl = environment.apiUrl + 'algorithm-version';

  constructor(private http: HttpClient) {}

  getVersion(): Observable<AlgorithmVersion> {
    return this.http.get<AlgorithmVersion>(this.apiUrl).pipe(
      catchError((error) => {
        console.error('Error fetching algorithm version:', error);
        return throwError(() => new Error('Failed to fetch algorithm version'));
      })
    );
  }
}
